// src/utils/push.js
import axios from '../app-axios';
import { webPushKey, backendUrl } from '../app-globals';

export async function subscribeToPush () {
  try {
    const sw = await navigator.serviceWorker.ready;

    let subscription = await sw.pushManager.getSubscription();

    if (!subscription) {
      subscription = await sw.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(webPushKey),
      });
      console.log('✅ New push subscription created');
      await sendSubscriptionToBackend(subscription);
    } else {
      console.log('ℹ️ Existing push subscription found');
      const savedSub = localStorage.getItem('push_subscription');
      if (savedSub !== JSON.stringify(subscription)) {
        await sendSubscriptionToBackend(subscription);
      }
    }
    localStorage.setItem('push_subscription', JSON.stringify(subscription));
  } catch (error) {
    console.error('❌ Error during push subscription:', error);
  }
}

async function sendSubscriptionToBackend (subscription) {
  await axios.post(`${backendUrl}/api/devices/web-push/notify`, subscription);
}

function urlBase64ToUint8Array (base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = atob(base64);
  return new Uint8Array([...rawData].map((char) => char.charCodeAt(0)));
}
